import { TruncatedTooltip } from "@/components/ui/truncated-tooltip";
import type { ReportItem } from "@/pages/dashboard/types";

interface ReportRowProps {
  item: ReportItem;
}

/**
 * One row inside a report's "가장 활발한 ..." list.
 * Name on the left, value on the right (left/right baseline aligned).
 */
const ReportRow = ({ item }: ReportRowProps) => {
  return (
    <div className="flex gap-2 items-baseline py-3 w-full">
      <TruncatedTooltip className="flex-1 min-w-0 text-sm leading-5 tracking-[-0.14px] text-black ">
        {item.name}
      </TruncatedTooltip>
      <p className="flex-1 min-w-0 text-sm leading-5 tracking-[-0.14px] text-black text-right">
        {item.value}
      </p>
    </div>
  );
};

export default ReportRow;
